<template>

    <div class="px-6 py-4 bg-minplan-beige -mb-4">
        <page-title :title="$t('apartments.apartmentStateChange')"></page-title>
    </div>

    <jet-form-section @submitted="updateState()">

        <template #form>
            <!-- Card Project State -->
            <form-card :title="$t('apartments.state')" :description="$t('apartments.apartmentStateDescription')">

                <radio-list
                    v-model="form.updateState.state"
                    :items="states" />

            </form-card>

        </template>

        <template #actions>
            <div class="flex justify-end my-4 mx-6">

                <button @click="cancel" type="button"
                        class="inline-block uppercase font-semibold text-xs tracking-widest">{{ $t("actions.cancel") }}
                </button>

                <primary-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="ml-3 ">
                    {{ $t("actions.save") }}
                </primary-button>
            </div>
        </template>

    </jet-form-section>

</template>


<script>
import { defineComponent } from "vue";
import MainLayout from "@/Layouts/MainLayout";
import PrimaryButton from "@/Jetstream/PrimaryButton";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetFormSection from "@/Jetstream/FormSection";
import JetInput from "@/Jetstream/Input";
import JetInputError from "@/Jetstream/InputError";
import JetLabel from "@/Jetstream/Label";
import FormCard from "@/Shared/Components/FormCard";
import PageTitle from "@/Shared/Components/PageTitle";
import { useForm } from "@inertiajs/inertia-vue3";
import RadioList from "@/Shared/Components/RadioList";


const states = [
    { name: "Aktiv", description: "Diese Wohnung kann bearbeitet werden.", code: "active" },
    { name: "Abgeschlossen", description: "Die Arbeiten an dieser Wohnung sind abgeschlossen.", code: "completed" }
];

export default defineComponent({
    props: ["apartment"],
    inheritAttrs: false,
    emits: ["closeModal"],
    layout: MainLayout,
    components: {
        PageTitle,
        FormCard,
        PrimaryButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
        RadioList
    },
    data() {
        return {
            form: useForm({
                updateState: {
                    state: this.states.find(s => s.code === this.apartment.state)
                }
            })
        };
    },
    methods: {
        cancel() {
            this.$emit("closeModal");
        },
        updateState() {
            this.form.updateState.state = this.form.updateState.state.code;
            this.form.put(this.route("advisors.apartments.update", this.apartment.uuid), {
                preserveScroll: true,
                onSuccess: () => this.$notify({
                    group: "success",
                    title: "actions.success",
                    text: "apartments.updated"
                })
            });
        }
    },
    setup() {
        return {
            states
        };
    }
});
</script>

<style scoped></style>
